import { render, staticRenderFns } from "./RadioGlobal.vue?vue&type=template&id=b0ec4296&"
import script from "./RadioGlobal.vue?vue&type=script&lang=js&"
export * from "./RadioGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports